module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-iphone_1.461f5194.png";